import { useState } from 'react';
import { avatarUrl } from '../../lib/format';
import styles from './Avatar.module.css';

interface AvatarProps {
  userId: string;
  avatarHash: string | null;
  name: string;
  size?: number;
  ring?: boolean;
}

/** Falls back to initials when the CDN is unreachable from inside the iframe. */
export function Avatar({ userId, avatarHash, name, size = 40, ring = false }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const initials = name.slice(0, 2).toUpperCase();

  return (
    <div
      className={`${styles.avatar} ${ring ? styles.ring : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size / 2.6) }}
      title={name}
    >
      {failed ? (
        initials
      ) : (
        <img
          className={styles.image}
          src={avatarUrl(userId, avatarHash, size * 2)}
          alt=""
          onError={() => setFailed(true)}
        />
      )}
    </div>
  );
}
